// extracted by extract-css-chunks-webpack-plugin
module.exports = {"adminButton":"admin-tool__adminButton__3xi5W"};